import { render, staticRenderFns } from "./NotificationResponse.vue?vue&type=template&id=8e418284"
import script from "./NotificationResponse.vue?vue&type=script&lang=js"
export * from "./NotificationResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports